'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var paper = function paper() {
  return import('@/page/exam/exam-paper');
};
var paperresult = function paperresult() {
  return import('@/page/exam/exam-paper/paperresult.vue');
};
var examlist = function examlist() {
  return import('@/page/exam/exam-list');
};
var exampractice = function exampractice() {
  return import('@/page/exam/exam-practice');
};
var exercise = function exercise() {
  return import('@/page/exam/exerciseData');
};
var examcertificate = function examcertificate() {
  return import('@/page/exam/exam-certificate/certificate');
};
var examcertificateDetail = function examcertificateDetail() {
  return import('@/page/exam/exam-certificate/certificate-detail');
};
exports.default = [{
  path: '/paper',
  name: 'paper',
  component: paper,
  childred: []
}, {
  path: '/paperresult',
  name: 'paperresult',
  component: paperresult,
  childred: []
}, {
  path: '/examlist',
  name: 'examlist',
  component: examlist,
  childred: []
}, {
  path: '/exampractice',
  name: 'exampractice',
  component: exampractice,
  childred: []
}, {
  path: '/exercise',
  name: 'exercise',
  component: exercise,
  childred: []
}, {
  path: '/examcertificate',
  name: 'examcertificate',
  component: examcertificate,
  childred: []
}, {
  path: '/examcertificateDetail',
  name: 'examcertificateDetail',
  component: examcertificateDetail,
  childred: []
}];